/**
 * Default email templates extracted from current implementation
 * Uses {{variable}} syntax for variable substitution
 * Uses {{SECTION:name}} for customizable section placeholders
 */

export const DEFAULT_TASK_REMINDER_SUBJECT = '{{organizationName}} - Task Reminder: {{taskTitle}}';

export const DEFAULT_TASK_REMINDER_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Task Reminder: {{taskTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">Task Reminder</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; border-left: 4px solid {{primaryColor}}; padding: 20px; margin: 20px 0; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
      <h2 style="margin: 0 0 10px 0; font-size: 20px; color: #111827;">{{taskTitle}}</h2>

      {{taskDescriptionHtml}}

      <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
        <div style="display: flex; flex-wrap: wrap; gap: 15px; font-size: 14px;">
          <div>
            <strong style="color: #6b7280;">Type:</strong>
            <span style="margin-left: 5px; text-transform: capitalize;">{{taskType}}</span>
          </div>
          <div>
            <strong style="color: #6b7280;">Priority:</strong>
            <span style="margin-left: 5px; text-transform: capitalize; color: {{taskPriorityColor}};">{{taskPriority}}</span>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <strong style="color: #6b7280;">Due Date:</strong>
          <span style="margin-left: 5px; font-weight: 600;">{{taskDueDate}}</span>
        </div>
      </div>
    </div>

    {{happeningSectionHtml}}

    <div style="text-align: center; margin: 30px 0;">
      <a href="{{taskLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        View Task →
      </a>
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_TASK_REMINDER_TEXT = `
Task Reminder

{{SECTION:greeting}}

{{SECTION:intro}}

{{taskTitle}}
{{taskDescription}}

Type: {{taskType}}
Priority: {{taskPriority}}
Due Date: {{taskDueDate}}

{{happeningSectionText}}

View this task: {{taskLink}}

{{SECTION:footer}}
`.trim();

// Profile Completion Reminder Templates
export const DEFAULT_PROFILE_COMPLETION_SUBJECT = '{{organizationName}} - Complete Your Profile: {{personName}}';

export const DEFAULT_PROFILE_COMPLETION_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Complete Your Profile: {{personName}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">Complete Your Profile</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; border-left: 4px solid {{primaryColor}}; padding: 20px; margin: 20px 0; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
      <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #111827;">Missing Information:</h2>
      <div style="color: #6b7280; font-size: 14px;">
        {{missingFieldsList}}
      </div>
    </div>

    <div style="text-align: center; margin: 30px 0;">
      <a href="{{inviteLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        Complete Profile →
      </a>
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_PROFILE_COMPLETION_TEXT = `
Complete Your Profile

{{SECTION:greeting}}

{{SECTION:intro}}

Missing Information:
{{missingFieldsText}}

Complete your profile: {{inviteLink}}

{{SECTION:footer}}
`.trim();

// Happening Completion Reminder Templates
export const DEFAULT_HAPPENING_COMPLETION_SUBJECT = '{{organizationName}} - Complete Show Details: {{happeningTitle}}';

export const DEFAULT_HAPPENING_COMPLETION_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Complete Show Details: {{happeningTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">Complete Show Details</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; border-left: 4px solid {{primaryColor}}; padding: 20px; margin: 20px 0; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
      <h2 style="margin: 0 0 15px 0; font-size: 18px; color: #111827;">Missing Information:</h2>
      <div style="color: #6b7280; font-size: 14px;">
        {{missingFieldsList}}
      </div>
    </div>

    <div style="text-align: center; margin: 30px 0;">
      <a href="{{stubLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        Complete Show Details →
      </a>
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_HAPPENING_COMPLETION_TEXT = `
Complete Show Details

{{SECTION:greeting}}

{{SECTION:intro}}

Missing Information:
{{missingFieldsText}}

Complete show details: {{stubLink}}

{{SECTION:footer}}
`.trim();

// Happening Stub Link Templates
export const DEFAULT_HAPPENING_STUB_LINK_SUBJECT = '{{organizationName}} - Your Show Link: {{happeningTitle}}';

export const DEFAULT_HAPPENING_STUB_LINK_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Complete Show Details: {{happeningTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">Complete Show Details</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="text-align: center; margin: 30px 0;">
      <a href="{{stubLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        Complete Show Details →
      </a>
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_HAPPENING_STUB_LINK_TEXT = `
Complete Show Details

{{SECTION:greeting}}

{{SECTION:intro}}

Complete show details: {{stubLink}}

{{SECTION:callToAction}}

{{SECTION:footer}}
`.trim();

// Happening Reminder Templates
export const DEFAULT_HAPPENING_REMINDER_SUBJECT = '{{organizationName}} - Upcoming Show: {{happeningTitle}}';

export const DEFAULT_HAPPENING_REMINDER_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Upcoming Show: {{happeningTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">Upcoming Show Reminder</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; border-left: 4px solid {{primaryColor}}; padding: 20px; margin: 20px 0; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
      <h2 style="margin: 0 0 10px 0; font-size: 20px; color: #111827;">{{happeningTitle}}</h2>

      <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
        <div style="font-size: 14px;">
          <strong style="color: #6b7280;">Start Time:</strong>
          <div style="margin-top: 5px; color: #111827;">
            {{happeningStartTime}}
          </div>
        </div>
      </div>

      {{locationSectionHtml}}

      <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
        <div style="font-size: 14px;">
          <strong style="color: #6b7280;">Arrival Instructions:</strong>
          <div style="margin-top: 5px; color: #111827;">
            {{SECTION:arrivalInstructions}}
          </div>
        </div>
      </div>

      <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
        <div style="font-size: 14px;">
          <strong style="color: #6b7280;">Contact:</strong>
          <div style="margin-top: 5px; color: #111827;">
            {{SECTION:contactDetails}}
          </div>
        </div>
      </div>
    </div>

    {{editLinkHtml}}

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      See you there!
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_HAPPENING_REMINDER_TEXT = `
Upcoming Show Reminder

{{SECTION:greeting}}

{{SECTION:intro}}

{{happeningTitle}}

Start Time: {{happeningStartTime}}

{{locationSectionText}}

Arrival Instructions:
{{SECTION:arrivalInstructions}}

Contact:
{{SECTION:contactDetails}}

{{editLinkText}}

See you there!

{{SECTION:footer}}
`.trim();

// Completion Notification Templates (sent to staff when artist completes profile/show details)
export const DEFAULT_COMPLETION_NOTIFICATION_SUBJECT = '{{organizationName}} - {{entityTypeLabel}} Completed: {{entityName}}';

export const DEFAULT_COMPLETION_NOTIFICATION_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{entityTypeLabel}} Completed: {{entityName}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">{{entityTypeLabel}} Completed</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; border-left: 4px solid #22c55e; padding: 20px; margin: 20px 0; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
      <h2 style="margin: 0 0 10px 0; font-size: 20px; color: #111827;">{{entityName}}</h2>

      <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
        <div style="font-size: 14px; color: #6b7280;">
          <p style="margin: 0 0 8px 0;">
            <strong>Type:</strong> <span style="text-transform: capitalize;">{{entityTypeLabel}}</span>
          </p>
          <p style="margin: 0 0 8px 0;">
            <strong>Completed by:</strong> {{completedByName}}
          </p>
          <p style="margin: 0;">
            <strong>Completed at:</strong> {{completedAt}}
          </p>
        </div>
      </div>
    </div>

    <div style="text-align: center; margin: 30px 0;">
      <a href="{{viewLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        View Details →
      </a>
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_COMPLETION_NOTIFICATION_TEXT = `
{{entityTypeLabel}} Completed

{{SECTION:greeting}}

{{SECTION:intro}}

{{entityName}}

Type: {{entityTypeLabel}}
Completed by: {{completedByName}}
Completed at: {{completedAt}}

View details: {{viewLink}}

{{SECTION:footer}}
`.trim();

// Combined Artist & Show Invite Templates
export const DEFAULT_ARTIST_AND_SHOW_INVITE_SUBJECT =
  "{{organizationName}} - You're performing on {{happeningTitle}}";

export const DEFAULT_ARTIST_AND_SHOW_INVITE_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>You're performing on {{happeningTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">

  <!-- Header with branding -->
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 10px 0 0 0; font-size: 24px;">You're Invited to Perform!</h1>
  </div>

  <!-- Main content -->
  <div style="background: #f9fafb; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">

    <!-- Greeting -->
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <!-- Show context (primary framing) -->
    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; padding: 15px; border-left: 4px solid {{primaryColor}}; margin: 20px 0; border-radius: 4px;">
      <div style="font-size: 14px; color: #6b7280;">
        <strong style="color: #111827;">Show Time:</strong> {{happeningStartTime}}<br>
        <strong style="color: #111827;">Venue:</strong> {{happeningPlace}}<br>
        <strong style="color: #111827;">Duration:</strong> {{happeningDuration}} minutes
      </div>
    </div>

    <!-- Instructions -->
    <p style="font-size: 16px; margin: 20px 0;">
      To get everything ready for your performance, we need you to complete your profile and add your show details.
    </p>

    <!-- Single CTA button -->
    <div style="text-align: center; margin: 30px 0;">
      <a href="{{combinedLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 14px 36px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        Complete Everything →
      </a>
    </div>

    <!-- Footer note -->
    <p style="font-size: 14px; color: #6b7280; margin: 25px 0 0 0; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <!-- Footer -->
  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>

</body>
</html>
`.trim();

export const DEFAULT_ARTIST_AND_SHOW_INVITE_TEXT = `
You're performing on {{happeningTitle}}

{{SECTION:greeting}}

{{SECTION:intro}}

Show Details:
- Time: {{happeningStartTime}}
- Venue: {{happeningPlace}}
- Duration: {{happeningDuration}} minutes

To get everything ready for your performance, please complete your profile and add your show details:

→ {{combinedLink}}

{{SECTION:callToAction}}

---
{{SECTION:footer}}
`.trim();

// Residency Creation Templates (sent when a new series is created with shows)
export const DEFAULT_RESIDENCY_CREATION_SUBJECT =
  "{{organizationName}} - Your {{seriesName}} residency has been created";

export const DEFAULT_RESIDENCY_CREATION_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Your {{seriesName}} Residency</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">

  <!-- Header with branding -->
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 10px 0 0 0; font-size: 24px;">Your Residency is Set!</h1>
  </div>

  <!-- Main content -->
  <div style="background: #f9fafb; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">

    <!-- Greeting -->
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <!-- Intro -->
    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <!-- Series info -->
    <div style="background: white; padding: 20px; border-left: 4px solid {{primaryColor}}; margin: 20px 0; border-radius: 4px;">
      <h2 style="margin: 0 0 10px 0; font-size: 18px; color: #111827;">{{seriesName}}</h2>
      <div style="font-size: 14px; color: #6b7280;">
        <strong style="color: #111827;">Schedule:</strong> {{frequency}}<br>
        <strong style="color: #111827;">Total Episodes:</strong> {{episodeCount}}
      </div>
    </div>

    <!-- Shows list -->
    <div style="margin: 25px 0;">
      <h3 style="margin: 0 0 15px 0; font-size: 16px; color: #111827;">Your Scheduled Shows:</h3>
      {{showListHtml}}
    </div>

    <!-- Instructions -->
    <p style="font-size: 14px; color: #6b7280; margin: 25px 0 0 0; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:callToAction}}
    </p>
  </div>

  <!-- Footer -->
  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>

</body>
</html>
`.trim();

export const DEFAULT_RESIDENCY_CREATION_TEXT = `
Your {{seriesName}} Residency is Set!

{{SECTION:greeting}}

{{SECTION:intro}}

Series: {{seriesName}}
Schedule: {{frequency}}
Total Episodes: {{episodeCount}}

YOUR SCHEDULED SHOWS:
{{showListText}}

{{SECTION:callToAction}}

---
{{SECTION:footer}}
`.trim();

// Post-Show Follow-up Templates (sent to artists after a show ends)
export const DEFAULT_POST_SHOW_SUBJECT =
  "{{organizationName}} - Thanks for playing {{happeningTitle}}!";

export const DEFAULT_POST_SHOW_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Thanks for playing {{happeningTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">

  <!-- Header with branding -->
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 10px 0 0 0; font-size: 24px;">Thanks for Playing!</h1>
  </div>

  <!-- Main content -->
  <div style="background: #f9fafb; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">

    <!-- Greeting -->
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <!-- Intro -->
    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <!-- Show info -->
    <div style="background: white; padding: 20px; border-left: 4px solid {{primaryColor}}; margin: 20px 0; border-radius: 4px;">
      <h2 style="margin: 0 0 10px 0; font-size: 18px; color: #111827;">{{happeningTitle}}</h2>
      <div style="font-size: 14px; color: #6b7280;">
        <strong style="color: #111827;">Date:</strong> {{happeningStartTime}}
      </div>
    </div>

    <!-- Links -->
    <div style="margin: 25px 0;">
      {{feedbackSectionHtml}}

      <div style="text-align: center; margin: 15px 0;">
        <a href="{{tracklistLink}}"
           style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 15px;">
          Share Your Tracklist →
        </a>
      </div>
    </div>

  </div>

  <!-- Footer -->
  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>

</body>
</html>
`.trim();

export const DEFAULT_POST_SHOW_TEXT = `
Thanks for playing {{happeningTitle}}!

{{SECTION:greeting}}

{{SECTION:intro}}

Show: {{happeningTitle}}
Date: {{happeningStartTime}}

{{feedbackSectionText}}

SHARE YOUR TRACKLIST:
{{tracklistLink}}

---
{{SECTION:footer}}
`.trim();

// Technical Update Notification Templates (sent to engineers when artist updates equipment/rider notes)
export const DEFAULT_TECHNICAL_UPDATE_NOTIFICATION_SUBJECT = '{{organizationName}} - Technical Update: {{happeningTitle}}';

export const DEFAULT_TECHNICAL_UPDATE_NOTIFICATION_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Technical Update: {{happeningTitle}}</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 0; font-size: 24px;">Technical Update</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; border-left: 4px solid #f59e0b; padding: 20px; margin: 20px 0; border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
      <h2 style="margin: 0 0 10px 0; font-size: 20px; color: #111827;">{{happeningTitle}}</h2>

      <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e5e7eb;">
        <div style="font-size: 14px; color: #6b7280;">
          <p style="margin: 0 0 8px 0;">
            <strong>Updated by:</strong> {{updatedByName}}
          </p>
          <p style="margin: 0 0 8px 0;">
            <strong>Updated at:</strong> {{updatedAt}}
          </p>
          <p style="margin: 0;">
            <strong>What changed:</strong> {{changeDescription}}
          </p>
        </div>
      </div>
    </div>

    <div style="text-align: center; margin: 30px 0;">
      <a href="{{viewLink}}"
         style="display: inline-block; background: {{primaryColor}}; color: white; text-decoration: none; padding: 12px 30px; border-radius: 6px; font-weight: 600; font-size: 16px;">
        View Show Details →
      </a>
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:footer}}
    </p>
  </div>

  <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #9ca3af; font-size: 12px;">
    <p style="margin: 0;">{{SECTION:footer}}</p>
  </div>
</body>
</html>
`.trim();

export const DEFAULT_TECHNICAL_UPDATE_NOTIFICATION_TEXT = `
Technical Update: {{happeningTitle}}

{{SECTION:greeting}}

{{SECTION:intro}}

Show: {{happeningTitle}}
Updated by: {{updatedByName}}
Updated at: {{updatedAt}}
What changed: {{changeDescription}}

View details: {{viewLink}}

{{SECTION:footer}}
`.trim();

// Archive Notification Templates (sent to artists when an archive/embed link is added to a show)
export const DEFAULT_ARCHIVE_NOTIFICATION_SUBJECT =
  '{{organizationName}} - Your show "{{happeningTitle}}" is now archived';

export const DEFAULT_ARCHIVE_NOTIFICATION_HTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Your show "{{happeningTitle}}" is now archived</title>
</head>
<body style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">

  <div style="background: linear-gradient(135deg, {{primaryColor}} 0%, {{secondaryColor}} 100%); padding: 30px; border-radius: 8px 8px 0 0; text-align: center;">
    {{logoHtml}}
    <h1 style="color: white; margin: 10px 0 0 0; font-size: 24px;">Your show is archived</h1>
  </div>

  <div style="background: #f9fafb; padding: 30px; border: 1px solid #e5e7eb; border-top: none; border-radius: 0 0 8px 8px;">

    <p style="font-size: 16px; margin: 0 0 20px 0;">{{SECTION:greeting}}</p>

    <p style="font-size: 16px; margin: 0 0 20px 0;">
      {{SECTION:intro}}
    </p>

    <div style="background: white; padding: 20px; border-left: 4px solid {{primaryColor}}; margin: 20px 0; border-radius: 4px;">
      <h2 style="margin: 0 0 10px 0; font-size: 18px; color: #111827;">{{happeningTitle}}</h2>
      <div style="font-size: 14px; color: #6b7280;">
        <strong style="color: #111827;">Date:</strong> {{happeningStartTime}}
      </div>
    </div>

    {{showPageSectionHtml}}

    <div style="margin: 25px 0;">
      <p style="font-size: 15px; margin: 0 0 10px 0; color: #111827;"><strong>{{archiveLinksHeading}}</strong></p>
      {{archiveLinksHtml}}
    </div>

    <p style="font-size: 14px; color: #6b7280; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
      {{SECTION:footer}}
    </p>

  </div>

</body>
</html>
`.trim();

export const DEFAULT_ARCHIVE_NOTIFICATION_TEXT = `
Your show "{{happeningTitle}}" is now archived

{{SECTION:greeting}}

{{SECTION:intro}}

Show: {{happeningTitle}}
Date: {{happeningStartTime}}

{{showPageSectionText}}
{{archiveLinksHeading}}
{{archiveLinksText}}

---
{{SECTION:footer}}
`.trim();
